import closestPolyfill from "./closest";

const polyfills = (): void => {
  closestPolyfill();
};

export default polyfills;
